var render = function render(){var _vm=this,_c=_vm._self._c;return _c('key-unit',{staticClass:"editor-info-editable-item",attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',[_c('el-date-picker',{attrs:{"append-to-body":false,"type":"date","placeholder":"选择日期"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }